import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import FitmentBanner from '../../library/fitment/components/fitment-banner/fitment-banner';
import FitMessage from './components/fit-message/fit-message';

import { useFitment } from '../../shared/hooks/hooks';

import { trackAction } from '../../shared/utils/analytics/analytics';
import { formatTireSizeParts } from '../../shared/utils/format/format';
import { ProductTypeProp } from '../../shared/utils/prop-types/prop-types';

import { DONT_FIT, EXCLUDED, FIT } from '../../shared/constants/fit';

import './fitment-page-banner.scss';

function FitmentPageBanner(props) {
  const {
    className,
    doesFitEnum,
    hideDivider,
    hideFitMessage,
    hideFitment,
    hideFitmentSize,
    hideRideHeight,
    hideVehicleImage,
    incompleteFitmentMessage,
    isLoading,
    isPackage,
    isSingular,
    isTextSearch,
    onEditFitment,
    productType,
    tireSizes
  } = props;

  const { partialFitment, selectedFitment } = useFitment();

  const partialFitmentWithSizes = partialFitment
    ? {
        ...partialFitment,
        frontTireSize: formatTireSizeParts(tireSizes?.front || {}),
        frontWheelDiameter: tireSizes?.front?.diameter,
        isStaggered: Boolean(tireSizes?.rear),
        rearTireSize: formatTireSizeParts(tireSizes?.rear || {}),
        rearWheelDiameter: tireSizes?.rear?.diameter
      }
    : undefined;

  const defaultEditFitment = useCallback(() => {
    window.location.hash = '#/fitment/vehicle/edit/confirm';
  }, []);

  return (
    <div className={className} styleName="container">
      {!hideFitMessage && (
        <>
          {!selectedFitment && (
            <FitMessage
              data-testid="FitMessage"
              doesFit={false}
              isPackage={isPackage}
              isSingular={isSingular}
              productType={productType}
            />
          )}
          {selectedFitment && doesFitEnum !== EXCLUDED && (
            <FitMessage
              data-testid="FitMessage"
              doesFit={doesFitEnum === FIT}
              fitment={selectedFitment}
              isLoading={isLoading}
              isPackage={isPackage}
              isSingular={isSingular}
              isTextSearch={isTextSearch}
              productType={productType}
            />
          )}
        </>
      )}
      {!hideFitment && (selectedFitment || partialFitment) && (
        <FitmentBanner
          fitment={selectedFitment || partialFitmentWithSizes}
          hideDelete
          hideFitmentSize={hideFitmentSize}
          hideRideHeight={hideRideHeight}
          hideVehicleImage={hideVehicleImage}
          incompleteFitmentMessage={incompleteFitmentMessage}
          isPartialFitment={!selectedFitment && partialFitment}
          onEditFitment={() => {
            typeof onEditFitment === 'function'
              ? onEditFitment()
              : defaultEditFitment();
            trackAction('vehicle_page_edit');
          }}
          showChangeVehicleLink
          showEditLink
          styleName="fitment-banner"
        />
      )}
      {selectedFitment && !hideDivider && <hr styleName="vehicle-divider" />}
    </div>
  );
}

FitmentPageBanner.propTypes = {
  className: PropTypes.string,
  doesFitEnum: PropTypes.oneOf([DONT_FIT, EXCLUDED, FIT]),
  hideDivider: PropTypes.bool,
  hideFitMessage: PropTypes.bool,
  hideFitment: PropTypes.bool,
  hideFitmentSize: PropTypes.bool,
  hideRideHeight: PropTypes.bool,
  hideVehicleImage: PropTypes.bool,
  incompleteFitmentMessage: PropTypes.string,
  isLoading: PropTypes.bool,
  isPackage: PropTypes.bool,
  isSingular: PropTypes.bool,
  isTextSearch: PropTypes.bool,
  onEditFitment: PropTypes.func,
  productType: ProductTypeProp,
  tireSizes: {
    front: PropTypes.arrayOf({
      crossDimension: PropTypes.string,
      diameter: PropTypes.string,
      height: PropTypes.string,
      width: PropTypes.string
    }),
    rear: PropTypes.arrayOf({
      crossDimension: PropTypes.string,
      diameter: PropTypes.string,
      height: PropTypes.string,
      width: PropTypes.string
    })
  }
};

export default FitmentPageBanner;
